import React from 'react';

import styles from './fileUploadListStyles';

import Link from 'buyside/components/presentation/Link/link';

import XMarkIcon from 'SVGs/x_mark';

import { getFilepathExtension, getExtensionIcon } from 'buyside/util/fileHelper';

const truncationLength = 30;

const fileUploadListItem = props => {
  const { file, name } = props.fileData;
  const { handleDelete, handleNameChange } = props;
  const fileExtension = getFilepathExtension(file.name);
  const FileIcon = getExtensionIcon(fileExtension);
  const truncatedName =
    file.name.length > truncationLength
      ? `${file.name.substring(0, truncationLength - 5)}....${fileExtension}`
      : file.name;
  return (
    <tr className={styles.fileUploadListItemArea}>
      <td>
        <Link to={file.preview} target="_blank" download={file.name}>
          <FileIcon className={styles.fileIcon} />
          {truncatedName}
        </Link>
      </td>
      <td>
        <input type="text" className={styles.nameInput} value={name} onChange={handleNameChange} />
        <XMarkIcon
          data-testid={`delete-${name}-icon`}
          onClick={handleDelete}
          className={styles.removeButton}
        />
      </td>
    </tr>
  );
};

export default fileUploadListItem;
